var _rect, _path, _circle, _circle2, _rect2, _rect3, _text, _rect4, _path2, _path3, _circle3, _path4, _rect5, _rect6, _rect7, _text2, _text3, _text4, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoultrypro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 48,
    fill: "#101114"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1200v760H0z",
    fill: "url(#grid)",
    opacity: 0.38
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 120,
    r: 210,
    fill: "#2DD4BF",
    opacity: 0.18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 610,
    r: 250,
    fill: "#F59E0B",
    opacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 116,
    width: 976,
    height: 528,
    rx: 32,
    fill: "#191B20",
    stroke: "rgba(255,255,255,.14)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 164,
    width: 268,
    height: 60,
    rx: 16,
    fill: "#2DD4BF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 186,
    y: 204,
    fill: "#101114",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 28,
    fontWeight: 800
  }, "POULTRYPRO")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 268,
    width: 258,
    height: 248,
    rx: 24,
    fill: "rgba(45,212,191,.12)",
    stroke: "rgba(45,212,191,.42)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286 337c33 0 60 27 60 60s-27 60-60 60-60-27-60-60 27-60 60-60Z",
    fill: "#2DD4BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M286 311c-9 16-23 26-40 29 14 6 27 6 40-1 13 7 26 7 40 1-17-3-31-13-40-29Z",
    fill: "#FDE68A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 387,
    r: 8,
    fill: "#101114"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301 394h42l-37 19c-4 2-9-1-9-6v-7c0-3 2-6 4-6Z",
    fill: "#F59E0B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 268,
    width: 244,
    height: 112,
    rx: 22,
    fill: "rgba(255,255,255,.07)",
    stroke: "rgba(255,255,255,.12)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 756,
    y: 268,
    width: 244,
    height: 112,
    rx: 22,
    fill: "rgba(255,255,255,.07)",
    stroke: "rgba(255,255,255,.12)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 416,
    width: 528,
    height: 100,
    rx: 22,
    fill: "rgba(255,255,255,.07)",
    stroke: "rgba(255,255,255,.12)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 498,
    y: 316,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fontWeight: 800
  }, "Flock Tracking")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 782,
    y: 316,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fontWeight: 800
  }, "Feed &amp; Health")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 498,
    y: 464,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fontWeight: 800
  }, "Mobile-first farm dashboard")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 338,
    width: 134,
    height: 12,
    rx: 6,
    fill: "#2DD4BF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 782,
    y: 338,
    width: 152,
    height: 12,
    rx: 6,
    fill: "#F59E0B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 486,
    width: 370,
    height: 12,
    rx: 6,
    fill: "#94A3B8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 562,
    width: 842,
    height: 18,
    rx: 9,
    fill: "rgba(255,255,255,.12)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 562,
    width: 612,
    height: 18,
    rx: 9,
    fill: "#2DD4BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 48,
    height: 48,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0v48",
    stroke: "white",
    strokeOpacity: 0.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoultrypro);
export default __webpack_public_path__ + "static/media/poultrypro.c3cf25ce55e718df0dfa809d89c67bad.svg";
export { ForwardRef as ReactComponent };